import { render } from "./redirects.vue?vue&type=template&id=03e38236&ts=true"
import script from "./redirects.vue?vue&type=script&lang=ts"
export * from "./redirects.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/build_c94111dd/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__